module.exports = __webpack_public_path__ + "img/baseball_softball_accessories.758dd219.svg";